module.exports = __webpack_public_path__ + "images/img_2_4-d7b6bbfdbc.png";